import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-general-info-tab',
  templateUrl: './general-info-tab.component.html',
  styleUrls: ['./general-info-tab.component.scss'],
  standalone: false
})
export class GeneralInfoTabComponent {
  @Input() product;
  generalInfoLeft: boolean = false;
  private sanitizer = inject(DomSanitizer);
  getObjectValuesVrm(valueString: string): { key: string, value: string }[] {
    const keyValuePairs = valueString
      .replace(/[{}]/g, '') // Remove curly braces
      .split(/,(?=\s*\d)/)  // Split into key-value pairs
      .map(pair => {
        const [key, value] = pair.trim().split('='); // Split key and value
        return { key, value };
      });
    return keyValuePairs;
  }
  getObjectValues(valueString: string): { key: string, value: string }[] {
    const keyValuePairs = valueString
      .replace(/[{}]/g, '') // Remove curly braces
      .split(',')  // Split into key-value pairs
      .map(pair => {
        const [key, value] = pair.trim().split('='); // Split key and value
        return { key, value: value?.replace(/;/g, ',') };
      });
    return keyValuePairs;
  }
  ngOnChanges() {

    if (this.product?.generalInfoMap) {
      this.product?.generalInfoMap.forEach((item) => {
        if (
          item.key == ('common.text_generalInfo_vrms') &&
          item.key == ('common.text_generalInfo_packaging') &&
          item.key == ('common.text_generalInfo_weight_dimensions')
        ) {
          this.generalInfoLeft = true;
        }
        else {
          this.generalInfoLeft = true;
        }
      });
    }
  }

  isAnyGeneralInfoAvailable(product: any) {
    if (!product.generalInfoMap) {
      return false;
    }
    const Keys = [
      'common.text_generalInfo_weight_dimensions',
      'common.text_generalInfo_packaging',
      'common.text_generalInfo_vrms'
    ]

    return Keys.some(key => product.generalInfoMap.some(info => info.key === key));
  }
  getSanitizedHtml(html: string): SafeHtml {

    return this.sanitizer.bypassSecurityTrustHtml(html);

  }
}
